import * as types from '../constants/actionTypes';
import { CALL_API } from '../helpers/api';

export const actions = {
    searchProjectLocations: (filterRequest) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/search',
                    method: 'POST',
                    body: filterRequest,
                    types: [
                        types.SEARCH_PROJECTLOCATION_REQUEST,
                        types.SEARCH_PROJECTLOCATION_SUCCESS,
                        types.SEARCH_PROJECTLOCATION_FAILURE
                    ]
                }
            });
        },
    loadProjectLocationListFilters: (projectKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/list-filters',
                    method: 'POST',
                    body: { projectKey: projectKey },
                    types: [
                        types.LOAD_PROJECTLOCATION_FILTERS_REQUEST,
                        types.LOAD_PROJECTLOCATION_FILTERS_SUCCESS,
                        types.LOAD_PROJECTLOCATION_FILTERS_FAILURE
                    ]
                }
            });
        },
    addToScope: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/add-to-scope',
                    method: 'POST',
                    body: request,
                    types: [
                        types.ADD_TO_PROJECTLOCATION_SCOPE_REQUEST,
                        types.ADD_TO_PROJECTLOCATION_SCOPE_SUCCESS,
                        types.ADD_TO_PROJECTLOCATION_SCOPE_FAILURE
                    ]
                }
            });
        },
    loadAllLocations: (projectKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/load-all-locations',
                    method: 'POST',
                    body: { projectKey: projectKey },
                    types: [
                        types.LOAD_ALL_PROJECTLOCATION_LOCATIONS_REQUEST,
                        types.LOAD_ALL_PROJECTLOCATION_LOCATIONS_SUCCESS,
                        types.LOAD_ALL_PROJECTLOCATION_LOCATIONS_FAILURE
                    ]
                }
            });
        },
    locationNameSearch: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/location-name-search',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SEARCH_PROJECTLOCATION_NAME_REQUEST,
                        types.SEARCH_PROJECTLOCATION_NAME_SUCCESS,
                        types.SEARCH_PROJECTLOCATION_NAME_FAILURE
                    ]
                }
            });
        },
    loadLocationFilters: (subscriptionId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/location-filters',
                    method: 'POST',
                    body: { subscriptionId: subscriptionId },
                    types: [
                        types.LOAD_PROJECTLOCATION_LOCATION_FILTERS_REQUEST,
                        types.LOAD_PROJECTLOCATION_LOCATION_FILTERS_SUCCESS,
                        types.LOAD_PROJECTLOCATION_LOCATION_FILTERS_FAILURE
                    ]
                }
            });
        },
    searchLocations: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/location-search',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SEARCH_PROJECTLOCATION_LOCATIONS_REQUEST,
                        types.SEARCH_PROJECTLOCATION_LOCATIONS_SUCCESS,
                        types.SEARCH_PROJECTLOCATION_LOCATIONS_FAILURE
                    ]
                }
            });
        },
    removeFromScope: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/remove-from-scope',
                    method: 'POST',
                    body: request,
                    types: [
                        types.REMOVE_FROM_PROJECTLOCATION_SCOPE_REQUEST,
                        types.REMOVE_FROM_PROJECTLOCATION_SCOPE_SUCCESS,
                        types.REMOVE_FROM_PROJECTLOCATION_SCOPE_FAILURE
                    ]
                }
            });
        },
    updateProjectManager: (projlocIds, pmId, projectKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/update-project-manager',
                    method: 'POST',
                    body: { projectLocationIds: projlocIds, projectManagerId: pmId, projectKey: projectKey },
                    types: [
                        types.UPDATE_PROJECTLOCATION_MANAGER_REQUEST,
                        types.UPDATE_PROJECTLOCATION_MANAGER_SUCCESS,
                        types.UPDATE_PROJECTLOCATION_MANAGER_FAILURE
                    ]
                }
            });
        },
    updateCoach: (coachId, projectId, locationId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/update-coach',
                    method: 'POST',
                    body: { 
                        coachId: coachId,
                        projectId: projectId,
                        locationId: locationId
                    },
                    types: [
                        types.UPDATE_PROJECTLOCATION_COACH_REQUEST,
                        types.UPDATE_PROJECTLOCATION_COACH_SUCCESS,
                        types.UPDATE_PROJECTLOCATION_COACH_FAILURE
                    ]
                }
            });
        },        
    pushdown: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/pushdown',
                    method: 'POST',
                    body: request,
                    types: [
                        types.PUSHDOWN_PROJECTLOCATION_REQUEST,
                        types.PUSHDOWN_PROJECTLOCATION_SUCCESS,
                        types.PUSHDOWN_PROJECTLOCATION_FAILURE
                    ]
                }
            });
        },
    addBaseline: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/add-baseline',
                    method: 'POST',
                    body: request,
                    types: [
                        types.ADD_BASELINE_PROJECTLOCATION_REQUEST,
                        types.ADD_BASELINE_PROJECTLOCATION_SUCCESS,
                        types.ADD_BASELINE_PROJECTLOCATION_FAILURE
                    ]
                }
            });
        },
    updateOnHold: (locationIds, projectKey, isOnHold) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/update-onhold',
                    method: 'POST',
                    body: {
                        projectLocationIds: locationIds,
                        projectKey: projectKey,
                        isOnHold: isOnHold
                    },
                    types: [
                        types.UPDATE_PROJECTLOCATION_ONHOLD_REQUEST,
                        types.UPDATE_PROJECTLOCATION_ONHOLD_SUCCESS,
                        types.UPDATE_PROJECTLOCATION_ONHOLD_FAILURE
                    ]
                }
            });
        },  
    updateZeroDate: (locationIds, projectKey, zeroDate, epicDates) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/update-zero-date',
                    method: 'POST',
                    body: {
                        projectLocationIds: locationIds,
                        projectKey: projectKey,
                        zeroDate: zeroDate,
                        epicDates: epicDates
                    },
                    types: [
                        types.UPDATE_PROJECTLOCATION_ZERODATE_REQUEST,
                        types.UPDATE_PROJECTLOCATION_ZERODATE_SUCCESS,
                        types.UPDATE_PROJECTLOCATION_ZERODATE_FAILURE
                    ]
                }
            });
        },
        updateEpicDates: (epicDates) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/update-epic-dates',
                    method: 'POST',
                    body: {
                        epicDates: epicDates
                    },
                    types: [
                        types.UPDATE_PROJECTLOCATION_EPICDATE_REQUEST,
                        types.UPDATE_PROJECTLOCATION_EPICDATE_SUCCESS,
                        types.UPDATE_PROJECTLOCATION_EPICDATE_FAILURE
                    ]
                }
            });
        },   
    revokePushdown: (locationIds, projectKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/revoke-pushdown',
                    method: 'POST',
                    body: {
                        projectLocationIds: locationIds,
                        projectKey: projectKey
                    },
                    types: [
                        types.REVOKE_PUSHDOWN_PROJECTLOCATION_REQUEST,
                        types.REVOKE_PUSHDOWN_PROJECTLOCATION_SUCCESS,
                        types.REVOKE_PUSHDOWN_PROJECTLOCATION_FAILURE
                    ]
                }
            });
        },
    loadPushdownFilters: (subscriptionId, projectKey) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/pushdown-filters',
                    method: 'POST',
                    body: { subscriptionId: subscriptionId, projectKey: projectKey },
                    types: [
                        types.LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_REQUEST,
                        types.LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_SUCCESS,
                        types.LOAD_PROJECTLOCATION_PUSHDOWN_FILTERS_FAILURE
                    ]
                }
            });
        },
    requestWaiver: (projectLocationId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/request-waiver',
                    method: 'POST',
                    body: { projectLocationId: projectLocationId },
                    types: [
                        types.REQUEST_PROJECTLOCATION_WAIVER_REQUEST,
                        types.REQUEST_PROJECTLOCATION_WAIVER_SUCCESS,
                        types.REQUEST_PROJECTLOCATION_WAIVER_FAILURE
                    ]
                }
            });
        },
    deleteWaiverRequest: (projectLocationId) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/delete-waiver-request',
                    method: 'POST',
                    body: { projectLocationId: projectLocationId },
                    types: [
                        types.DELETE_PROJECTLOCATION_WAIVER_REQUEST_REQUEST,
                        types.DELETE_PROJECTLOCATION_WAIVER_REQUEST_SUCCESS,
                        types.DELETE_PROJECTLOCATION_WAIVER_REQUEST_FAILURE
                    ]
                }
            });
        },
    waiverSearch: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/waiver-search',
                    method: 'POST',
                    body: request,
                    types: [
                        types.SEARCH_PROJECTLOCATION_WAIVER_REQUEST,
                        types.SEARCH_PROJECTLOCATION_WAIVER_SUCCESS,
                        types.SEARCH_PROJECTLOCATION_WAIVER_FAILURE
                    ]
                }
            });
        },
    waiverApproveDeny: (request) =>
        (dispatch) => {
            return dispatch({
                [CALL_API]: {
                    endpoint: 'projectlocation/approve-deny-waivers',
                    method: 'PUT',
                    body: request,
                    types: [
                        types.APPROVE_DENY_PROJECTLOCATION_WAIVER_REQUEST,
                        types.APPROVE_DENY_PROJECTLOCATION_WAIVER_SUCCESS,
                        types.APPROVE_DENY_PROJECTLOCATION_WAIVER_FAILURE
                    ]
                }
            });
        }
}
